import { put, takeLatest, delay } from "@redux-saga/core/effects";

import {
  loadRules,
  loadRulesFail,
  loadRulesSuccess,
  updateRules,
  updateRulesFail,
  updateRulesSuccess,
  updatePosition,
  actionDuplicate,
  deleteDuplicate,
  createRules,
  createDuplicate3rd,
  updateDuplicate3rd,
  notify,
  loadAllRules,
  loadAllRulesSuccess,
  runAnalysis,
  setLoadingDetails,
  downloadAnalysis,
  loadValueDuplicate,
  loadValueDuplicateResult,
  loadRecordDuplicateDetail,
  loadRecordDuplicateDetailResult,
  loadFieldsDuplicateDetail,
  loadFieldsDuplicateDetailResult,
  setActiveValueID,
  updateSettingAnalysis,
  runAnalysisResult,
} from "redux/slices/duplicateRules";
import fileDownload from "js-file-download";

import { Notification } from "components/Notification/Noti";
import {
  loadRulesAPI,
  updateRulesAPI,
  updatePositionAPI,
  actionDuplicateAPI,
  deleteDuplicateAPI,
  createRulesAPI,
  createDuplicate3rdAPI,
  updateDuplicate3rdAPI,
  deleteThirdPartyAPI,
  notifyAPI,
  getAllRules,
  runAnalysisAPI,
  downloadAnalysisAPI,
  loadValueDuplicateAPI,
  loadRecordDuplicateDetailAPI,
  loadFieldsDuplicateDetailAPI,
  updateSettingAnalysisAPI,
} from "redux/api/duplicateRulesAPI";
import { setShowLoadingScreen } from "redux/slices/global";
import { forEach, get, map } from "lodash";

export default function* duplicateRules() {
  yield takeLatest(loadRules.type, LoadRules);
  yield takeLatest(updateRules.type, UpdateRules);
  yield takeLatest(updatePosition.type, UpdatePosition);
  yield takeLatest(actionDuplicate.type, ActionDuplicate);
  yield takeLatest(deleteDuplicate.type, DeleteDuplicate);
  yield takeLatest(createRules.type, CreateRules);
  yield takeLatest(createDuplicate3rd.type, CreateDuplicate3rd);
  yield takeLatest(updateDuplicate3rd.type, UpdateDuplicate3rd);
  yield takeLatest(notify.type, Notify);
  yield takeLatest(loadAllRules.type, LoadAllRules);
  yield takeLatest(runAnalysis.type, RunAnalysis);
  yield takeLatest(downloadAnalysis.type, DownloadAnalysis);
  yield takeLatest(loadValueDuplicate.type, LoadValueDuplicate);
  yield takeLatest(loadRecordDuplicateDetail.type, LoadRecordDuplicateDetail);
  yield takeLatest(loadFieldsDuplicateDetail.type, LoadFieldsDuplicateDetail);
  yield takeLatest(updateSettingAnalysis.type, UpdateSettingAnalysis);
}

function* LoadRules(action) {
  try {
    const response = yield loadRulesAPI(action.payload);
    yield put(loadRulesSuccess(response.data.data));
    yield delay(1500);
    yield put(setLoadingDetails(false));
  } catch (error) {
    yield put(loadRulesFail());
    yield put(setLoadingDetails(false));
  }
}

function* LoadAllRules(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const response = yield getAllRules();
    yield put(loadAllRulesSuccess(response.data.data));
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
  }
}

function* UpdateRules(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield updateRulesAPI(action.payload);
    yield put(updateRulesSuccess());
    yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (error) {
    yield put(updateRulesFail());
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* UpdatePosition(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield updatePositionAPI(action.payload);
    yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* ActionDuplicate(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield actionDuplicateAPI(action.payload);
    yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* DeleteDuplicate(action) {
  try {
    yield put(setShowLoadingScreen(true));
    if (action.payload.third_party) {
      yield deleteThirdPartyAPI(action.payload);
    } else {
      yield deleteDuplicateAPI(action.payload);
    }
    const response = yield loadRulesAPI(action.payload);
    yield put(loadRulesSuccess(response.data.data));
    yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* CreateRules(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield createRulesAPI({
      ...action.payload,
      isEdit: undefined,
    });

    if (action.payload?.isEdit && action.payload?.rules?.length > 0) {
      yield put(
        loadRules({
          object_id: action.payload.object_id,
        })
      );
    } else {
      yield put(loadAllRules());
    }

    // const response = yield loadRulesAPI(action.payload);
    // yield put(loadRulesSuccess(response.data.data));
    yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* CreateDuplicate3rd(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield createDuplicate3rdAPI(action.payload);

    const response = yield loadRulesAPI(action.payload);
    yield put(loadRulesSuccess(response.data.data));

    yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* UpdateDuplicate3rd(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield updateDuplicate3rdAPI(action.payload);

    const response = yield loadRulesAPI(action.payload);
    yield put(loadRulesSuccess(response.data.data));

    yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* Notify(action) {
  try {
    // yield put(setShowLoadingScreen(true));
    yield notifyAPI(action.payload);
    // yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (error) {
    // yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* RunAnalysis(action) {
  try {
    yield runAnalysisAPI(action.payload);
    yield put(runAnalysisResult());
  } catch (error) {
    Notification("error", error.response.data.error);
    yield put(runAnalysisResult());
  }
}

function* DownloadAnalysis(action) {
  try {
    const response = yield downloadAnalysisAPI(action.payload);
    Notification("success", "Download successfully!");
    fileDownload(response.data, `Analysis.xlsx`);
  } catch (error) {
    error.response.data.text().then((err) => {
      Notification("error", JSON.parse(err).error);
    });
  }
}

function* LoadValueDuplicate(action) {
  try {
    const response = yield loadValueDuplicateAPI(action.payload);
    yield put(loadValueDuplicateResult(response.data.data));
    if (response.data.data?.length > 0 && action.payload.current_page === 1) {
      yield put(setActiveValueID(response.data.data[0]?.value_id));

      yield put(
        loadFieldsDuplicateDetail({
          object_id: action.payload.object_id,
        })
      );
      yield put(
        loadRecordDuplicateDetail({
          object_id: action.payload.object_id,
          value_id: response.data.data[0]?.value_id,
          current_page: 1,
          record_per_page: 10,
        })
      );
    }
  } catch (error) {
    yield put(loadValueDuplicateResult([]));
    Notification("error", error.response.data.error);
  }
}

function* LoadRecordDuplicateDetail(action) {
  try {
    const response = yield loadRecordDuplicateDetailAPI(action.payload);

    const values = [];

    forEach(response.data.data, (item) => {
      let temp = {};
      Object.entries(item).forEach(([key, value]) => {
        if (key === "_id") {
          temp = {
            ...temp,
            key: value,
          };
        } else {
          temp = {
            ...temp,
            [key]: get(value, "value") || value,
          };
        }
      });
      values.push(temp);
    });

    yield put(loadRecordDuplicateDetailResult(values));
  } catch (error) {
    yield put(loadRecordDuplicateDetailResult([]));
    Notification("error", error.response.data.error);
  }
}

function* LoadFieldsDuplicateDetail(action) {
  try {
    const response = yield loadFieldsDuplicateDetailAPI(action.payload);

    const fields = map(response.data.data, (item) => ({
      key: item.ID,
      title: item.name,
      dataIndex: item.ID,
    }));

    yield put(loadFieldsDuplicateDetailResult(fields));
  } catch (error) {
    yield put(loadFieldsDuplicateDetailResult([]));
    Notification("error", error.response.data.error);
  }
}

function* UpdateSettingAnalysis(action) {
  try {
    yield updateSettingAnalysisAPI(action.payload);
    yield put(
      loadFieldsDuplicateDetail({
        object_id: action.payload.object_id,
      })
    );
    Notification("success", "Successfully!");
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}
